import styled from "styled-components";

export const FooterShell = styled.footer`
  border-top: 1px solid #e2e8f0;
`;
export const FooterInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 40px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  font-size: 0.9rem;
  color: #64748b;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
export const FooterLinks = styled.div`
  display: flex;
  gap: 24px;
  font-weight: 450;
  a {
    color: #24ae7c;
  }
  a:hover {
    text-decoration: underline;
  }
`;
